export const membersData = [
  {
    aid: "001",
    index: 0,
    status: "Active",
    name: "Isabel Hill",
    email: "isabelhill@portica.com",
    registered: "Members",
    roles : [1,2,3]
  },
  {
    aid: "002",
    index: 1,
    status: "Inactive",
    name: "Craig Nunez",
    email: "craignunez@portica.com",
    registered: "Members",
    roles : [1]
  },
  {
    aid: "003",
    index: 2,
    status: "Active",
    name: "Alisha Hester",
    email: "alishahester@portica.com",
    registered: "Members",
    roles : [1]
  },
  {
    aid: "004",
    index: 3,
    status: "Active",
    name: "Moses Stout",
    email: "mosesstout@portica.com",
    registered: "Members",
    roles : [1]
  },
  {
    aid: "005",
    index: 4,
    status: "Active",
    name: "Mendoza Gibson",
    email: "mendozagibson@portica.com",
    registered: "Members",
    roles : [1]
  },
  {
    aid: "006",
    index: 5,
    status: "Active",
    name: "Flora Macias",
    email: "floramacias@portica.com",
    registered: "Members",
    roles : [1]
  },
  {
    aid: "007",
    index: 6,
    status: "Active",
    name: "Parsons Ray",
    email: "parsonsray@portica.com",
    registered: "Members",
    roles : [1]
  },
  {
    aid: "008",
    index: 7,
    status: "Active",
    name: "Candice Webb",
    email: "candicewebb@portica.com",
    registered: "Members",
    roles : [1]
  },
  {
    aid: "009",
    index: 8,
    status: "Active",
    name: "Bradford Barker",
    email: "bradfordbarker@portica.com",
    registered: "Members",
    roles : [1]
  },
  {
    aid: "010",
    index: 9,
    status: "Active",
    name: "Edna Gallegos",
    email: "ednagallegos@portica.com",
    registered: "Members",
    roles : [1]
  },
  {
    aid: "011",
    index: 10,
    status: "Active",
    name: "Margie Solomon",
    email: "margiesolomon@portica.com",
    registered: "Members",
    roles : [1]
  },
  {
    aid: "012",
    index: 11,
    status: "Active",
    name: "Spencer Harrison",
    email: "spencerharrison@portica.com",
    registered: "Members",
    roles : [1]
  },
  {
    aid: "013",
    index: 12,
    status: "Active",
    name: "Francisca Rodgers",
    email: "franciscarodgers@portica.com",
    registered: "Members",
    roles : [1]
  },
  {
    aid: "014",
    index: 13,
    status: "Active",
    name: "Elba Heath",
    email: "elbaheath@portica.com",
    registered: "Members",
    roles : [1]
  },
  {
    aid: "015",
    index: 14,
    status: "Active",
    name: "Katharine Wooten",
    email: "katharinewooten@portica.com",
    registered: "Members",
    roles : [1]
  },
  {
    aid: "016",
    index: 15,
    status: "Active",
    name: "Willa Petersen",
    email: "willapetersen@portica.com",
    registered: "Members",
    roles : [1]
  },
  {
    aid: "017",
    index: 16,
    status: "Active",
    name: "Gale Snow",
    email: "galesnow@portica.com",
    registered: "Members",
    roles : [1]
  },
  {
    aid: "018",
    index: 17,
    status: "Active",
    name: "Ann Blevins",
    email: "annblevins@portica.com",
    registered: "Members",
    roles : [1]
  },
  {
    aid: "019",
    index: 18,
    status: "Active",
    name: "Randolph Olson",
    email: "randolpholson@portica.com",
    registered: "Members",
    roles : [1]
  },
  {
    aid: "020",
    index: 19,
    status: "Inactive",
    name: "Beck Kline",
    email: "beckkline@portica.com",
    registered: "Members",
    roles : [1]
  },
];

export const usersData = [
  {
    aid: "001",
    index: 0,
    status: "Cancelled",
    name: "Isabel Hill",
    email: "isabelhill@portica.com",
    phone: "+1 (847) 472-2607",
    registered: "2018-01-19 02:36 PM",
  },
  {
    aid: "002",
    index: 1,
    status: "Paid",
    name: "Craig Nunez",
    email: "craignunez@portica.com",
    phone: "+1 (888) 522-3330",
    registered: "2015-12-13 02:38 AM",
  },
  {
    aid: "003",
    index: 2,
    status: "Trial",
    name: "Alisha Hester",
    email: "alishahester@portica.com",
    phone: "+1 (851) 540-3483",
    registered: "2018-12-31 03:09 AM",
  },
  {
    aid: "004",
    index: 3,
    status: "Trial",
    name: "Moses Stout",
    email: "mosesstout@portica.com",
    phone: "+1 (871) 476-2593",
    registered: "2016-10-12 06:50 PM",
  },
  {
    aid: "005",
    index: 4,
    status: "Paid",
    name: "Mendoza Gibson",
    email: "mendozagibson@portica.com",
    phone: "+1 (910) 409-2057",
    registered: "2015-12-09 09:51 PM",
  },
  {
    aid: "006",
    index: 5,
    status: "Cancelled",
    name: "Flora Macias",
    email: "floramacias@portica.com",
    phone: "+1 (933) 486-2366",
    registered: "2015-06-02 01:50 PM",
  },
  {
    aid: "007",
    index: 6,
    status: "Cancelled",
    name: "Parsons Ray",
    email: "parsonsray@portica.com",
    phone: "+1 (876) 480-2976",
    registered: "2016-08-22 02:13 PM",
  },
  {
    aid: "008",
    index: 7,
    status: "Cancelled",
    name: "Candice Webb",
    email: "candicewebb@portica.com",
    phone: "+1 (933) 468-3014",
    registered: "2018-03-29 05:02 AM",
  },
  {
    aid: "009",
    index: 8,
    status: "Paid",
    name: "Bradford Barker",
    email: "bradfordbarker@portica.com",
    phone: "+1 (829) 514-2280",
    registered: "2015-01-13 11:19 AM",
  },
  {
    aid: "010",
    index: 9,
    status: "Paid",
    name: "Edna Gallegos",
    email: "ednagallegos@portica.com",
    phone: "+1 (876) 576-2016",
    registered: "2015-08-13 07:22 PM",
  },
  {
    aid: "011",
    index: 10,
    status: "Trial",
    name: "Margie Solomon",
    email: "margiesolomon@portica.com",
    phone: "+1 (898) 431-3340",
    registered: "2014-10-12 01:36 PM",
  },
  {
    aid: "012",
    index: 11,
    status: "Paid",
    name: "Spencer Harrison",
    email: "spencerharrison@portica.com",
    phone: "+1 (958) 496-3739",
    registered: "2015-10-12 03:36 PM",
  },
  {
    aid: "013",
    index: 12,
    status: "Paid",
    name: "Francisca Rodgers",
    email: "franciscarodgers@portica.com",
    phone: "+1 (934) 449-2204",
    registered: "2019-01-21 12:05 PM",
  },
  {
    aid: "014",
    index: 13,
    status: "Paid",
    name: "Elba Heath",
    email: "elbaheath@portica.com",
    phone: "+1 (903) 409-2961",
    registered: "2018-11-06 09:30 PM",
  },
  {
    aid: "015",
    index: 14,
    status: "Activated",
    name: "Katharine Wooten",
    email: "katharinewooten@portica.com",
    phone: "+1 (908) 526-3634",
    registered: "2015-04-05 11:43 AM",
  },
  {
    aid: "016",
    index: 15,
    status: "Activated",
    name: "Willa Petersen",
    email: "willapetersen@portica.com",
    phone: "+1 (978) 422-2256",
    registered: "2017-12-23 02:55 PM",
  },
  {
    aid: "017",
    index: 16,
    status: "Activated",
    name: "Gale Snow",
    email: "galesnow@portica.com",
    phone: "+1 (846) 551-2079",
    registered: "2018-11-01 07:35 AM",
  },
  {
    aid: "018",
    index: 17,
    status: "Trial",
    name: "Ann Blevins",
    email: "annblevins@portica.com",
    phone: "+1 (875) 542-3969",
    registered: "2014-05-10 06:18 PM",
  },
  {
    aid: "019",
    index: 18,
    status: "Cancelled",
    name: "Randolph Olson",
    email: "randolpholson@portica.com",
    phone: "+1 (966) 505-3463",
    registered: "2014-05-12 10:02 AM",
  },
  {
    aid: "020",
    index: 19,
    status: "Activated",
    name: "Beck Kline",
    email: "beckkline@portica.com",
    phone: "+1 (955) 491-2230",
    registered: "2018-05-14 11:21 PM",
  },
];

export const transactionData = [
  {
    index: 1,
    orderId: "91d49b",
    transactionId: "trans-7cc989",
    aid: 1,
    name: "Stacie Rodgers",
    paymentMethod: "Card Payment",
    status: "Paid",
    amount: "$3,930.32",
    paidTime: "2015-02-10",
    orderStatus: "Transaction Failed",
  },
  {
    index: 2,
    orderId: "7f0cd5",
    transactionId: "trans-1e5a64",
    aid: 2,
    name: "Jami Blevins",
    paymentMethod: "Card Payment",
    status: "Cancelled",
    amount: "$1,514.35",
    paidTime: "2017-07-18",
    orderStatus: "Confirmed",
  },
  {
    index: 3,
    orderId: "850dd8",
    transactionId: "trans-68f8af",
    aid: 3,
    name: "Phillips York",
    paymentMethod: "Paypal",
    status: "Paid",
    amount: "$3,010.87",
    paidTime: "2019-03-03",
    orderStatus: "Confirmed",
  },
  {
    index: 4,
    orderId: "8b2b43",
    transactionId: "trans-2df683",
    aid: 4,
    name: "Keller Hancock",
    paymentMethod: "Stripe",
    status: "Cancelled",
    amount: "$1,437.70",
    paidTime: "2016-09-09",
    orderStatus: "Confirmed",
  },
  {
    index: 5,
    orderId: "691e2e",
    transactionId: "trans-45f26b",
    aid: 5,
    name: "Conner Fields",
    paymentMethod: "Paypal",
    status: "Cancelled",
    amount: "$2,277.72",
    paidTime: "2017-11-13",
    orderStatus: "Transaction Failed",
  },
  {
    index: 6,
    orderId: "8b8ee8",
    transactionId: "trans-531c65",
    aid: 6,
    name: "Geraldine Cole",
    paymentMethod: "Card Payment",
    status: "Cancelled",
    amount: "$3,342.79",
    paidTime: "2018-06-30",
    orderStatus: "Confirmed",
  },
  {
    index: 7,
    orderId: "af15da",
    transactionId: "trans-505c75",
    aid: 7,
    name: "William Little",
    paymentMethod: "Paypal",
    status: "Paid",
    amount: "$2,472.84",
    paidTime: "2018-04-12",
    orderStatus: "Success",
  },
  {
    index: 8,
    orderId: "dfa667",
    transactionId: "trans-cd4a6a",
    aid: 8,
    name: "Rae Shepherd",
    paymentMethod: "Card Payment",
    status: "Cancelled",
    amount: "$3,467.36",
    paidTime: "2016-02-14",
    orderStatus: "Transaction Failed",
  },
  {
    index: 9,
    orderId: "6909d5",
    transactionId: "trans-093a96",
    aid: 9,
    name: "Nola Hendrix",
    paymentMethod: "Paypal",
    status: "Paid",
    amount: "$1,597.22",
    paidTime: "2014-07-25",
    orderStatus: "Success",
  },
  {
    index: 10,
    orderId: "c78edb",
    transactionId: "trans-a420af",
    aid: 10,
    name: "Meghan Weeks",
    paymentMethod: "Card Payment",
    status: "Paid",
    amount: "$1,259.03",
    paidTime: "2014-01-13",
    orderStatus: "Cancelled",
  },
  {
    index: 11,
    orderId: "b46479",
    transactionId: "trans-6e556a",
    aid: 11,
    name: "Rojas Alford",
    paymentMethod: "Paypal",
    status: "Paid",
    amount: "$3,020.20",
    paidTime: "2017-08-21",
    orderStatus: "Success",
  },
  {
    index: 12,
    orderId: "338a03",
    transactionId: "trans-c9e93b",
    aid: 12,
    name: "Reilly Villarreal",
    paymentMethod: "Paypal",
    status: "Cancelled",
    amount: "$3,750.42",
    paidTime: "2017-10-31",
    orderStatus: "Cancelled",
  },
  {
    index: 13,
    orderId: "2c11b9",
    transactionId: "trans-bbd0f6",
    aid: 13,
    name: "Corina Lindsay",
    paymentMethod: "Paypal",
    status: "Cancelled",
    amount: "$3,097.34",
    paidTime: "2014-12-20",
    orderStatus: "Confirmed",
  },
  {
    index: 14,
    orderId: "47bbc0",
    transactionId: "trans-a19a0d",
    aid: 14,
    name: "Lesley Briggs",
    paymentMethod: "Card Payment",
    status: "Cancelled",
    amount: "$1,952.42",
    paidTime: "2018-07-12",
    orderStatus: "Transaction Failed",
  },
  {
    index: 15,
    orderId: "86c547",
    transactionId: "trans-c0ae53",
    aid: 15,
    name: "Bennett Hensley",
    paymentMethod: "Stripe",
    status: "Cancelled",
    amount: "$1,452.66",
    paidTime: "2015-12-08",
    orderStatus: "Confirmed",
  },
  {
    index: 16,
    orderId: "5c82cc",
    transactionId: "trans-5c82cc",
    aid: 16,
    name: "Flores Stewart",
    paymentMethod: "Stripe",
    status: "Cancelled",
    amount: "$1,382.52",
    paidTime: "2019-01-28",
    orderStatus: "Cancelled",
  },
  {
    index: 17,
    orderId: "5c82cc",
    transactionId: "trans-5c82cc",
    aid: 17,
    name: "Jocelyn Powers",
    paymentMethod: "Paypal",
    status: "Paid",
    amount: "$1,068.08",
    paidTime: "2015-07-18",
    orderStatus: "Success",
  },
  {
    index: 18,
    orderId: "5c82cc",
    transactionId: "trans-5c82cc",
    aid: 18,
    name: "Vonda Stout",
    paymentMethod: "Paypal",
    status: "Cancelled",
    amount: "$2,191.71",
    paidTime: "2016-03-28",
    orderStatus: "Confirmed",
  },
  {
    index: 19,
    orderId: "5c82cc",
    transactionId: "trans-5c82cc",
    aid: 19,
    name: "Coleman Armstrong",
    paymentMethod: "Stripe",
    status: "Cancelled",
    amount: "$2,564.08",
    paidTime: "2016-07-26",
    orderStatus: "Confirmed",
  },
  {
    index: 20,
    orderId: "5c82cc",
    transactionId: "trans-5c82cc",
    aid: 20,
    name: "Dollie Garza",
    paymentMethod: "Card Payment",
    status: "Paid",
    amount: "$3,080.64",
    paidTime: "2014-06-14",
    orderStatus: "Confirmed",
  },
];

export const auditLogData = [
  {
    index: 1,
    bandwidthConsumed: "8.2MB",
    type: "Download",
    name: "Larry Boom",
    userip: "127.0.0.1",
    change: "Mon Apr 30 2018 07:44:04 GMT+0530 (India Standard Time)",
  },
  {
    index: 2,
    bandwidthConsumed: "30.7MB",
    type: "Upload",
    name: "Larry Boom",
    userip: "127.0.0.1",
    change: "Fri Sep 25 2015 02:53:19 GMT+0530 (India Standard Time)",
  },
  {
    index: 3,
    bandwidthConsumed: "14.99MB",
    type: "Download",
    name: "Larry Boom",
    userip: "127.0.0.1",
    change: "Tue Jun 17 2014 18:47:26 GMT+0530 (India Standard Time)",
  },
  {
    index: 4,
    bandwidthConsumed: "6.67MB",
    type: "Download",
    name: "Larry Boom",
    userip: "127.0.0.1",
    change: "Fri May 20 2016 19:22:04 GMT+0530 (India Standard Time)",
  },
  {
    index: 5,
    bandwidthConsumed: "40.44MB",
    type: "Upload",
    name: "Larry Boom",
    userip: "127.0.0.1",
    change: "Thu Jul 03 2014 20:09:24 GMT+0530 (India Standard Time)",
  },
  {
    index: 6,
    bandwidthConsumed: "41.85MB",
    type: "Download",
    name: "Larry Boom",
    userip: "127.0.0.1",
    change: "Tue Nov 01 2016 14:51:04 GMT+0530 (India Standard Time)",
  },
  {
    index: 7,
    bandwidthConsumed: "61.31MB",
    type: "Download",
    name: "Larry Boom",
    userip: "127.0.0.1",
    change: "Tue Jul 01 2014 19:43:52 GMT+0530 (India Standard Time)",
  },
  {
    index: 8,
    bandwidthConsumed: "19.38MB",
    type: "Download",
    name: "Larry Boom",
    userip: "127.0.0.1",
    change: "Tue Mar 12 2019 15:35:39 GMT+0530 (India Standard Time)",
  },
  {
    index: 9,
    bandwidthConsumed: "20.39MB",
    type: "Download",
    name: "Larry Boom",
    userip: "127.0.0.1",
    change: "Wed Jul 09 2014 16:49:22 GMT+0530 (India Standard Time)",
  },
  {
    index: 10,
    bandwidthConsumed: "95.75MB",
    type: "Upload",
    name: "Larry Boom",
    userip: "127.0.0.1",
    change: "Fri Jun 08 2018 08:26:34 GMT+0530 (India Standard Time)",
  },
];

export const roles = [
  {
    rid: 1,
    role: "Admin"
  },
  {
    rid: 2,
    role: "Standard"
  }
];

export const permissions = [
  {
    pid: 1,
    permission: "Manage Users",
    get: true,
    post: true,
    put: true,
    delete: false
  },
  {
    pid: 2,
    permission: "Manage Transactions",
    get: true,
    post: true,
    put: true,
    delete: false
  },
  {
    pid: 3,
    permission: "Manage Users & Admins",
    get: true,
    post: false,
    put: false,
    delete: false
  },
  {
    pid: 4,
    permission: "Manage Subscription",
    get: true,
    post: true,
    put: true,
    delete: false
  },
  {
    pid: 5,
    permission: "Manage Subnets",
    get: true,
    post: true,
    put: false,
    delete: false
  },
  {
    pid: 6,
    permission: "Manage Use Cases",
    get: true,
    post: true,
    put: false,
    delete: false
  },
  {
    pid: 7,
    permission: "Manage Tags",
    get: true,
    post: true,
    put: false,
    delete: false
  }
];

export const actionsAvailable = [
  {
    title: "GET",
    id: "get"
  },
  {
    title: "POST",
    id: "post"
  },
  {
    title: "PUT",
    id: "put"
  },
  {
    title: "DELETE",
    id: "delete"
  }
];

export const subscriptions = [
  {
    product: "Product #1",
    status: "Active",
    startDate: "31-03-2019",
    paymentDue: "30-06-2019",
    amount: "$199"
  },
  {
    product: "Product #2",
    status: "Renew now",
    startDate: "29-03-2018",
    paymentDue: "29-06-2018",
    amount: "$80"
  },
  {
    product: "Product #3",
    status: "Active",
    startDate: "30-01-2019",
    paymentDue: "30-04-2019",
    amount: "$80"
  },
  {
    product: "Product #4",
    status: "Renew now",
    startDate: "29-01-2019",
    paymentDue: "29-02-2019",
    amount: "$100"
  }
];
